import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import {
  InfiniteScrollModule,
  OverlayLoaderModule,
  PaginatedList,
  PriceList,
  PriceListProduct,
} from 'cloud-shared-lib';
import * as _ from 'lodash';
import { BehaviorSubject, Observable, Subject, combineLatest } from 'rxjs';
import { debounceTime, map, share, startWith, switchMap, tap } from 'rxjs/operators';

import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { OrderDetailService } from '../../../order-detail.service';
import { ProductCardComponent } from './product-card/product-card.component';

@Component({
  selector: 'cutting-price-list-products-carded',
  templateUrl: './price-list-products-carded.component.html',
  standalone: true,
  imports: [NgIf, NgFor, AsyncPipe, OverlayLoaderModule, InfiniteScrollModule, ProductCardComponent],
})
export class PriceListProductsCardedComponent {
  @Input() priceList: PriceList;

  @Output() selectedProductChange: EventEmitter<number> = new EventEmitter();

  data$: Observable<PaginatedList<PriceListProduct>>;
  loading$: Observable<boolean>;

  selectedGroupIdChange: Subject<number> = new Subject();

  public filter: BehaviorSubject<string> = new BehaviorSubject('');

  initialPagination: Pick<PageEvent, 'pageIndex' | 'pageSize'> = {
    pageIndex: 0,
    pageSize: 30,
  };
  paginator: BehaviorSubject<Pick<PageEvent, 'pageIndex' | 'pageSize'>> = new BehaviorSubject(this.initialPagination);

  data: PriceListProduct[] = [];

  @Input() set selectedGroupId(val: number) {
    this.selectedGroupIdChange.next(val);
  }

  constructor(private orderDetailService: OrderDetailService) {
    this.data$ = combineLatest([
      this.selectedGroupIdChange.pipe(tap(() => this.reset())),
      this.filter.pipe(tap(() => this.reset())),
      this.paginator,
    ]).pipe(
      debounceTime(50),
      switchMap(([group, filter, paginator]) => {
        // if search
        if (!_.isEmpty(filter) && !_.isNil(filter)) {
          return this.orderDetailService.getPriceListProducts(
            this.priceList.id,
            group,
            filter,
            paginator.pageIndex,
            paginator.pageSize
          );

          // load main page
        } else if (group !== 0) {
          return this.orderDetailService.getPriceListProducts(
            this.priceList.id,
            group,
            undefined,
            paginator.pageIndex,
            paginator.pageSize
          );
        }
      }),
      tap(v => this.data.push(...(v.items ?? []))),
      share()
    );

    this.loading$ = this.data$.pipe(
      startWith(null),
      map(d => !d?.items)
    );
  }

  selectProduct(productId: number): void {
    this.selectedProductChange.emit(productId);
  }

  reset(): void {
    this.paginator.next(this.initialPagination);
    this.data = [];
  }

  onScroll(): void {
    this.paginator.next({ ...this.paginator.value, pageIndex: this.paginator.value.pageIndex + 1 });
  }
}
